import {useState, useEffect} from 'react';
import {tasveerStore} from '../firebase/config';


const useThumbFirestore = (collection) => {
    const [ThumbDocs, setThumbDocs] = useState([]);
    useEffect(() => {
        const unsub = tasveerStore.collection(collection)
        .orderBy('createdAt', 'desc')
        .onSnapshot((snap) => {
            let documents = [];
            snap.forEach(doc => {
                documents.push({...doc.data(), id: doc.id});
            });
            setThumbDocs(documents);
        })
        return () => unsub();
    } , [collection]);

    return { ThumbDocs };
}


export default useThumbFirestore;